import wixWindow from 'wix-window';

$w.onReady(function () {

});

export function repeater2_itemReady($item, itemData, index) {
	switch (wixWindow.multilingual.currentLanguage) {
		case 'he':
        console.log(itemData.nameHe);
			$item('#button12').label = '<< קרא עוד'
			$item('#button13').label = itemData.nameHe
			
			break;
	
		default:
        	$item('#button13').label = itemData.title
			$item('#button12').label = 'Read More >>'
			break;
	}
}